import styles from "./SegmentedControl.module.css";
import { cx } from "../cx";

export type SegmentedOption<V extends string> = { value: V; label: string };

export type SegmentedControlProps<V extends string> = {
  options: readonly SegmentedOption<V>[];
  value: V;
  onChange: (value: V) => void;
  className?: string;
  "aria-label"?: string;
};

/** SEED SegmentedControl (Figma 59:955). 45px, 2~3 items. */
export function SegmentedControl<V extends string>({ options, value, onChange, className, ...rest }: SegmentedControlProps<V>) {
  return (
    <div role="radiogroup" className={cx(styles.root, className)} aria-label={rest["aria-label"]}>
      {options.map((o) => {
        const selected = o.value === value;
        return (
          <button
            key={o.value}
            type="button"
            role="radio"
            aria-checked={selected}
            className={cx(styles.item, selected && styles.selected)}
            onClick={() => onChange(o.value)}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
